/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import ActionButton from '@components/navbar/ActionButton';

import BranchListScreen from '@/screens/setting/branch-list/BranchListScreen';
import BranchListDetailScreen from '@/screens/setting/branch-list/BranchListDetailScreen';
import BranchListFormScreen from '@/screens/setting/branch-list/BranchListFormScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const BranchListNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  const goToForm = (props, isAdd = false) => {
    if (
      !isAdd &&
      props &&
      props.route &&
      props.route.params &&
      props.route.params.id
    ) {
      props.navigation.navigate('BranchListFormScreen', {
        titleScreen: props.route.params.name,
        name: props.route.params.name,
        id: props.route.params.id,
      });
    } else {
      props.navigation.navigate('BranchListFormScreen');
    }
  };

  return (
    <Stack.Navigator
      initialRouteName="BranchListScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="BranchListScreen"
        component={BranchListScreen}
        options={() => ({
          // headerRight (incl. the mobile Add) is owned by BranchListScreen so
          // Add goes through openChild and preserves the list on return.
          title: setTitleHeader('Branch List'),
        })}
      />
      <Stack.Screen
        name="BranchListFormScreen"
        component={BranchListFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Branch';
          let isEdit = false;
          let params = {};
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            isEdit = true;
            params = route.params;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() (pop) not replace() — create->back preserves the
                // migrated list instance (openChild).
                isJump={true}
                customBack={{
                  screen: isEdit
                    ? 'BranchListDetailScreen'
                    : 'BranchListScreen',
                  params: params,
                }}
              />
            ),
            headerRight: isWeb
              ? () => <NotificationSettingButton {...props} />
              : false,
          };
        }}
      />
      <Stack.Screen
        name="BranchListDetailScreen"
        component={BranchListDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Branch List Detail';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() to the list — history stays aligned because the
                // edit form used replace() (no sandwiched detail entry).
                onPress={() => props.navigation.navigate('BranchListScreen')}
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() => goToForm(props)}
                />
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default BranchListNavigator;
